// @ts-nocheck: converted from JS

import Show from './Show';
import { Routes, Route } from 'react-router-dom';
import Create from '@/components/Glossary/Sections/Approvals/Create';
import Edit from '@/components/Glossary/Sections/Approvals/Edit';

const Approvals = () => {
  return (
    <Routes>
      <Route path="/" element={<Show />} />
      <Route path="/create" element={<Create />} />
      <Route path="/:approvalTemplate/edit" element={<Edit />} />
    </Routes>
  );
};

export default Approvals;
